<template>
 <div>
  <footer class="footerdiv">
    <section class="section container07">
      <div class="neit">
        <div class="z"> <img src="@/assets/styles/images/ic12.png" alt="">
          <p>友情链接</p>
        </div>
        <div class="y"> 
          <a v-for="item in linkList" :key="item.id" :href="item.link_url" :target="item.is_blank==1?'_blank':''">{{item.link_title}}</a> 
        </div>
      </div>
    </section>
    <ul class="da">
      <li style="width:70%">
        <div v-for="item in helpList" :key="item.class_id">
          <a :href="'/cms/help/listother-'+item.class_id" target="_blank" style="opacity:1"><h4>{{item.class_name}}</h4></a>
          <a v-for="childitem in item.child_list" :key="childitem.id" :href="'/cms/help-'+childitem.id" target="_blank">{{childitem.title}}</a> 
        </div>
          
      </li>
      <li>
        <div>
          <div class="zh"> <img src="@/assets/styles/images/er.png" alt="" class="i1"> <img src="@/assets/styles/images/ic17.gif" alt="" class="i2"> </div>
          <h3>微信公众号</h3>
        </div>
        <div>
          <div class="zh"> <img src="@/assets/styles/images/miniQrcode.jpg" alt="" class="i1"> <img src="@/assets/styles/images/ic17.gif" alt="" class="i2"> </div>
          <h3>微信小程序</h3>
        </div>
      </li>
      <!-- <li>
        <h4>
          <p>485985</p>
          <span>个</span> </h4>
        <p class="tj">商城注册用户统计</p>
      </li> -->
    </ul>
  </footer>
    <div class="friendlink" >
      <div>
        <a :href="copyRight.copyright_link" target="_blank" class="xia" style="margin-right:10px">{{copyRight.company_name}}</a>
        <p class="xia">|</p>
        <a :href="copyRight.gov_url" target="_blank" class="xia" style="margin-left:10px;margin-right:10px">{{copyRight.icp}}</a>
		 <p class="xia">|</p>
		<a target="_blank" style="margin-left:10px;"  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61019002002088">
		   <img border="0" hspace="0" vspace="0" src="@/assets/images/aq1.png" style="width:18px;height:18px"/>
		   陕公网安备 61019002002088号
		</a>
		 	 
		 
        <span id="cnzz_stat_icon_1279510410" style="margin-left:10px">
          <a href="https://www.cnzz.com/stat/website.php?web_id=1279510410" target="_blank" title="站长统计">
            <img border="0" hspace="0" vspace="0" src="https://icon.cnzz.com/img/pic.gif">
          </a>
        </span>
          <!-- <a class="gongshang" href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=91610131757832490H-SAIC_SHOW_10000091610131757832490H1629442298666&signData=MEQCIGYU3q+YXXgHxKbG4ZBglJwXD5Vv4bnFYrh9v66oeDXOAiCuZ7yx9I/Bg/oZLVGOJ+05NULR1Wgc00EuCtEl91MHEw==" target="_blank">
            <img src="@/assets/styles/images/gongshang.png" alt="电子亮照" title="电子亮照"> 
          </a> -->
            <a class="gongshang" href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=91610131757832490H-SAIC_SHOW_10000091610131757832490H1660618044703&signData=MEQCIBi7axXaTtdha8jTe/T/+Tm/yUe/nImmYt0sb0NFI3hlAiA2z9XqmyFVjbRsykTJ2VBI3zvHSMUMTmLX1iDg1mF9Sw==" target="_blank">
            <img src="@/assets/styles/images/gongshang.png" alt="电子亮照" title="电子亮照"> 
          </a>
          
          <!-- <a class="gongshang" :href="require('@/assets/styles/images/zengzhi.jpg')" target="_blank">
            <img src="@/assets/styles/images/zengzhi.jpg" alt="增值电信业务经营许可证" title="增值电信业务经营许可证">
          </a> -->
          <el-image style="width:20px;height:20px;margin-left:15px" :preview-src-list="zzlist" :src="require('@/assets/styles/images/zzicon.png')" title="相关资质" alt="相关资质"> </el-image>
      </div>
    
    </div>



</div>
</template>

<script>

import { copyRight, friendlyLink } from "@/api/website";
import { helpList } from "@/api/cms/help";
export default {
	props: {

	},
	data() {
		return {
      linkList:[],
      helpList:[],
      copyRight:{},
      zzlist:[require('@/assets/styles/images/zengzhi.png'),
              require('@/assets/styles/images/spjy.jpg')]
		};
	},
  created() {
    this.link()
    this.getcopyRight();
    this.getHelpList();
  },
	components: {
	
	},
	computed: {
		
	},
	mounted() {
    
  },
	methods: {
    getHelpList() {
                helpList({order:'sort desc'})
                    .then(res => {
                        if (res.code == 0 && res.data) {
                            var arr = [];
                            arr = res.data.slice(0, 5)

                            for (let i=0; i<arr.length; i++) {
                                arr[i].child_list = arr[i].child_list.slice(0, 3);
                            }

                            this.helpList = arr;
                        }
                    })
                    .catch(err => {})
            }, 
    getcopyRight() {
      copyRight({

      }).then(res => {
        if (res.code == 0 && res.data) {
          this.copyRight = res.data;
        }
      })
    },
            link() {
                friendlyLink({})
                    .then(res => {
                        if (res.code == 0 && res.data) {
                            this.linkList = res.data.list;
                        }
                    })
                    .catch(err => {
                        //this.$message.error(err.message)
                    })
            },
	}
};
</script>